import { Building2, Home, KeyRound, ClipboardList, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const AUDIENCES = [
  {
    id: "agences",
    icon: Building2,
    role: "Agences immobilières",
    tag: "Délégation intégrale",
    desc: "Déléguez vos états des lieux lors des pics de rotation : vos négociateurs restent concentrés sur la location et la vente, avec un niveau de rigueur irréprochable.",
  },
  {
    id: "proprietaires",
    icon: Home,
    role: "Propriétaires particuliers",
    tag: "Protection du patrimoine",
    desc: "Un constat neutre, précis et documenté qui protège votre bien et sécurise la retenue du dépôt de garantie en cas de dégradation.",
  },
  {
    id: "conciergeries",
    icon: KeyRound,
    role: "Conciergeries",
    tag: "Haute fréquence",
    desc: "Des interventions souples et cadencées entre deux séjours, avec un inventaire exhaustif du mobilier pour les logements meublés.",
  },
  {
    id: "gestionnaires",
    icon: ClipboardList,
    role: "Gestionnaires locatifs",
    tag: "Volume & exploitation",
    desc: "Des rapports standardisés et immédiatement exploitables pour vos comparatifs entrée / sortie et vos chiffrages de réparations locatives.",
  },
];

export default function TargetAudienceSection() {
  return (
    <section id="pour-qui" data-testid="audience-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeading
          eyebrow="Pour qui ?"
          title="Un service taillé pour les professionnels de l'immobilier"
          subtitle="Agences, propriétaires, conciergeries et gestionnaires : un même niveau d'exigence, un même dossier exploitable à chaque transition locative."
        />

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {AUDIENCES.map((a, i) => (
            <Reveal key={a.id} delay={i * 0.08} className="h-full">
              <article
                data-testid={`audience-card-${a.id}`}
                className="group flex h-full flex-col rounded-2xl border border-white/10 bg-elevated/60 p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-cyan-500/40 hover:shadow-[0_12px_40px_rgba(6,182,212,0.15)]"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-cyan-400/25 bg-cyan-400/10 text-cyan-300">
                    <a.icon className="h-5 w-5" />
                  </span>
                  <ArrowUpRight className="h-4 w-4 text-slate-600 transition-colors group-hover:text-cyan-400" />
                </div>
                <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.22em] text-cyan-400">
                  {a.tag}
                </p>
                <h3 className="mt-2 font-display text-lg font-bold text-white">{a.role}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-300">{a.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
